import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../../../../../../store/rootReducer';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IInfluencerDistribution } from '../../../../../../../influencer/offer/dto/IInfluencerDistribution';
import { Button, Image, Table } from 'react-bootstrap';
import { CustomAutocomplete } from '../../../../../../../../shared/components/Autocomplete';
import { addAdditionalItem, setDistributionItems } from '../../../../../../../../store/brand/offerBrandSlice';
import { useMediaQuery } from '@mui/material';
import { BootstrapBreakpoints } from '../../../../../../../../enum/BootstrapBreakpoints';

export function OptionalItemsTable() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isDesktop = useMediaQuery(`(min-width: ${BootstrapBreakpoints.XL}px)`);
    const { campaign, initialOffer, distributionArr } = useSelector((state: IAllStates) => state.offerBrand);
    const { OfferItemDurationEnum, country } = useSelector((states: IAllStates) => states.enums);

    const [expended, setExpended] = useState(true);

    const multipleSelectHandler = (paramKey: string, paramValue: any, type: string) => {
        let initialDistributionCopy: IInfluencerDistribution[];
        if (campaign) {
            initialDistributionCopy = [...distributionArr];
            const selectedItem = initialDistributionCopy.find(item => item.type === type);
            const index = selectedItem ? initialDistributionCopy.indexOf(selectedItem) : 0;
            initialDistributionCopy[index] = {
                ...initialDistributionCopy[index],
                [paramKey]: paramValue,
            };
            dispatch(setDistributionItems(initialDistributionCopy));
        }
    };

    const createAdditionalItem = (type: string) => {
        if (campaign) {
            const initialDistributionCopy = [...distributionArr];
            const selectedAdditionalItem = initialDistributionCopy.find(item => item.type === type);
            dispatch(addAdditionalItem(selectedAdditionalItem));
        }
    };

    const checkIfAdditionalAlreadyExist = (type: string) => {
        const additionalItemsCopy = [...initialOffer?.distribution];
        if (additionalItemsCopy.find(item => item.type === type)) {
            return true;
        }
        return false;
    };

    return (
        <div className="table-offer-items optional-table-offer-items">
            <Table responsive className={`table-head-bg mt-3`}>
                <thead className="table-head-bg cursor-pointer" onClick={() => setExpended(!expended)}>
                    <tr>
                        <th>{t('influencer.offer_management.modal.optional_items')}</th>
                        <th>{t('influencer.offer_management.modal.details')}</th>
                        <th>{t('brand.campaign.book.offer.modal.duration')}</th>
                        <th>{t('brand.campaign.book.offer.modal.location')}</th>
                        <th className="text-end">
                            {t('brand.campaign.book.offer.modal.action')}
                            {expended ? (
                                <Image className="ml-3" alt="image-up" src="/icons/img_arrow_up.svg" />
                            ) : (
                                <Image className="ml-3" alt="image-down" src="/icons/img_arrow_down.svg" />
                            )}
                        </th>
                    </tr>
                </thead>
                <tbody className={`${expended ? '' : 'd-none'} `}>
                    {distributionArr.map((item, i: number) => (
                        <tr
                            key={`${item?.type}-${i}`}
                            className={`${
                                checkIfAdditionalAlreadyExist(item?.type) ? 'd-none' : 'show-table-offer-items'
                            }`}
                        >
                            <td>{t(`influencer.offer_management.modal.${item?.type}`)}</td>
                            <td>{item?.typeDescription}</td>
                            <td width={130}>
                                <CustomAutocomplete
                                    dataArray={OfferItemDurationEnum}
                                    isMultiple={false}
                                    isWithImage={false}
                                    inputLabel="Publication Period"
                                    queryFilterKey="duration"
                                    defaultArray={item?.duration}
                                    inputLabelTranslation={`Duration`}
                                    handleChangeParams={(_, e) => multipleSelectHandler(_, e, item?.type)}
                                />
                            </td>
                            <td>
                                {!!item?.location && (
                                    <CustomAutocomplete
                                        dataArray={country}
                                        isWithImage={true}
                                        inputLabel="country"
                                        isMultiple={true}
                                        defaultArray={item?.location ? item?.location : []}
                                        photoLabel="countryFlag"
                                        queryFilterKey="location"
                                        limitTags={isDesktop ? 3 : 1}
                                        inputLabelTranslation={`${t('brand.campaign.book.offer.filters.location')}`}
                                        handleChangeParams={(_, e) => multipleSelectHandler(_, e, item.type)}
                                    />
                                )}
                            </td>
                            <td className="text-end">
                                <Button
                                    size="sm"
                                    variant="outline-primary"
                                    onClick={() => createAdditionalItem(item?.type)}
                                >
                                    {t('general.button.add')}
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
}
